import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaRoom } from '../../../../potree/utils/PointoramaRoom';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncRoomsConfig({ viewer, annotations, groups }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[]; groups: Project['state']['groups'] }): SyncConfig<Annotation, PointoramaRoom> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'ROOM'),
    getSceneItems: () => [...viewer.scene.rooms],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source) => {
      // Room constructor + loadReactiveProperties() loads geometry from property system
      const room = new PointoramaRoom(viewer);
      room.identifier = source.identifier;
      room.groupName = groups.find((g) => g.identifier === source.groupIdentifier)?.name ?? '';
      room.groupIdentifier = source.groupIdentifier || null;
      room.finished = true;
      return room;
    },
    addToScene: (item) => viewer.scene.addRoom(item),
    removeFromScene: (item) => viewer.scene.removeRoom(item),
  };
}
